/* eslint-disable import/no-unresolved */
import { Component } from 'preact'
import classnames from 'classnames'
import { Link } from 'preact-router/match'
import { route } from 'preact-router'
import { connect } from 'react-redux'
import { getP } from 'redux-polyglot'
import ReactGA from 'react-ga'

import {
  errorInput,
  focusInput,
  login,
  setStatus,
  updateInput,
  loginFacebook,
} from 'actions/login'
import AppBar from 'components/app-bar'
import Redirect from 'components/common/redirect'
import Modal from 'components/modal'
import styles from 'components/styles/login.css'
import modalStyles from 'components/styles/modal.css'
import {
  LOGIN_INPUT_PASSWORD,
  LOGIN_INPUT_USERNAME,
  LOGIN_STATUS_FAILED,
  LOGIN_STATUS_PROCESSING,
  LOGIN_STATUS_SUCCESS,
  LOGIN_STATUS_WAITING,
} from 'constants/login'
import { getAppName, isLoggedIn, selectRemoveRegister } from 'selectors/app'
import {
  getFocusedInput,
  getPassword,
  getPasswordError,
  getStatus,
  getUsername,
  getUsernameError,
} from 'selectors/login'
import SocialAuth from 'components/social-auth'
import { gaPageView } from 'libs/gaPageView'

class Login extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    gaPageView()
  }

  getSourceQuery = () => {
    let source = []
    if (this.props.matches && this.props.matches.src) {
      source.push(`src=${this.props.matches.src}`)
      if (this.props.matches.ctgid) {
        source.push(`ctgid=${this.props.matches.ctgid}`)
      }
      if (this.props.matches.subid) {
        source.push(`subid=${this.props.matches.subid}`)
      }
      if (this.props.matches.tid) {
        source.push(`tid=${this.props.matches.tid}`)
      }
    }
    return source.join('&')
  }

  getRedirectUrl = _ => {
    let redirectUrl
    switch (this.props.matches.src) {
      case 'account':
        redirectUrl = `${__webpack_public_path__ || '/'}account`
        break
      case 'checkout':
        redirectUrl = `${__webpack_public_path__ || '/'}checkout`
        break
      case 'dvr':
        redirectUrl = `${__webpack_public_path__ || '/'}dvr`
        break
      case 'live':
        redirectUrl = `${__webpack_public_path__ || '/'}live`
        break
      case 'support':
        redirectUrl = `${__webpack_public_path__ || '/'}support`
        break
      case 'popular':
      case 'recent':
      case 'top':
      case 'ctg':
        redirectUrl = `${__webpack_public_path__ || '/'}video/watch/${
          this.props.matches.id
        }?${this.getSourceQuery()}`
        break
      case 'search':
        redirectUrl = `${__webpack_public_path__ || '/'}search`
        break
      case 'previews':
        redirectUrl = `${__webpack_public_path__ || '/'}checkout`
        break
      default:
        redirectUrl = `${__webpack_public_path__ || '/'}`
        break
    }

    return redirectUrl
  }

  inputHandleClick = focusedInput => event => {
    event.preventDefault()
    event.stopPropagation()
    this.props.focusInput(focusedInput)
  }

  handleChange = e => {
    const key = e.target.value
    this.props.updateInput(key)
  }

  login = event => {
    event.preventDefault()
    event.stopPropagation()
    if (!this.validateUsername()) {
      this.props.focusInput(LOGIN_INPUT_USERNAME)
    } else if (!this.validatePassword()) {
      this.props.focusInput(LOGIN_INPUT_PASSWORD)
    } else {
      this.props.login(this.props.username, this.props.password)
    }
  }

  goToHome = event => {
    event.preventDefault()
    event.stopPropagation()
    route(`${__webpack_public_path__ || '/'}`)
  }

  validateUsername = () => {
    const {
      polyglot: { t },
    } = this.props
    if (this.props.username === '') {
      this.props.errorInput(
        LOGIN_INPUT_USERNAME,
        t('tv_auth.error_username_email_empty', {
          _: 'The username or email cannot be empty',
        })
      )
      return false
    } else {
      return true
    }
  }

  validatePassword = () => {
    const {
      polyglot: { t },
    } = this.props
    if (this.props.password === '') {
      this.props.errorInput(
        LOGIN_INPUT_PASSWORD,
        t('tv_auth.error_password_empty', { _: 'The password cannot be empty' })
      )
      return false
    } else {
      return true
    }
  }

  _getSourceQuery = () => {
    let source = []
    if (this.props.matches && this.props.matches.src) {
      source.push(`src=${this.props.matches.src}`)
      if (this.props.matches.ctgid) {
        source.push(`ctgid=${this.props.matches.ctgid}`)
      }
      if (this.props.matches.subid) {
        source.push(`subid=${this.props.matches.subid}`)
      }
      if (this.props.matches.tid) {
        source.push(`tid=${this.props.matches.tid}`)
      }
      if (this.props.matches.id) {
        source.push(`id=${this.props.matches.id}`)
      }
    }
    return source.join('&')
  }

  render({ polyglot: { t } }) {
    if (this.props.isLoggedIn || this.props.status === LOGIN_STATUS_SUCCESS) {
      return <Redirect to={this.getRedirectUrl()} />
    }

    return (
      <div className="component">
        <div className="componentBody">
          <AppBar
            title={t('tv_auth.title_login', {
              _: 'Login with Username or Email and Password',
            })}
            subtitle={t('tv_auth.subtitle_login', {
              _: 'to continue with %{app_name}',
              app_name: this.props.appName,
            })}
          />

          <div className={styles.container}>
            <div className={styles['login-container']}>
              <div className={styles['login-header']}>
                <div className={styles['login-header__text']}>Log In</div>
                <div className={styles['login-header__label']}>
                  to continue
                </div>
              </div>
              <div
                className={classnames(styles['form-control'], {
                  [styles.alert]: this.props.usernameError,
                })}
              >
                <input
                  type="text"
                  placeholder={t('tv_auth.label_username_email', {
                    _: 'Username or email',
                  })}
                  value={this.props.username}
                  onChange={this.handleChange}
                  onFocus={this.inputHandleClick(LOGIN_INPUT_USERNAME)}
                  onClick={this.inputHandleClick(LOGIN_INPUT_USERNAME)}
                />
              </div>

              <div
                className={classnames(styles['form-control'], {
                  [styles.alert]: this.props.passwordError,
                })}
              >
                <input
                  type="password"
                  placeholder={t('tv_auth.label_password', { _: 'Password' })}
                  value={this.props.password}
                  onChange={this.handleChange}
                  onFocus={this.inputHandleClick(LOGIN_INPUT_PASSWORD)}
                  onClick={this.inputHandleClick(LOGIN_INPUT_PASSWORD)}
                />
              </div>
              <div className={styles['forgot-password']}>
                <Link
                  href={`${__webpack_public_path__ ||
                    '/'}restore?${this._getSourceQuery()}`}
                >
                  Forgot Password?
                </Link>
              </div>
              <div className={styles['form-control']}>
                <button className={styles.loginBtn} type="submit" onClick={this.login}>
                  Log In
                </button>
              </div>

              <div className={styles['login-header__label']}>or Log In with</div>
              <SocialAuth onFacebookSuccess={this.props.loginFacebook} />
            </div>
            <div className={styles['register-container']}>
              <div className={styles['register-container__text']}>
                Don't have an account?
              </div>
              {!this.props.removeRegister && (
                <div className={styles.signUp}>
                  <Link
                    href={`${__webpack_public_path__ ||
                      '/'}auth/register?${this._getSourceQuery()}`}
                  >
                    Sign Up
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>

        {this.props.status === LOGIN_STATUS_FAILED ? (
          <Modal isFocused={false}>
            <div className={modalStyles.content}>
              <div className={modalStyles.title}>
                {t('tv_auth.login_failed_title', { _: 'Login failed!' })}
              </div>
              <div className={modalStyles.message}>
                {t('tv_auth.login_failed_description', {
                  _: 'Please check your login information details and try again.',
                })}
              </div>
            </div>
            <div className={modalStyles.btns}>
              <div
                className={modalStyles.btn}
                isFocused={true}
                onClick={() => this.props.setStatus(LOGIN_STATUS_WAITING)}
              >
                OK
              </div>
            </div>
          </Modal>
        ) : null}
        {this.props.status === LOGIN_STATUS_PROCESSING ? (
          <Modal isFocused={true}>
            <div className={modalStyles.content}>
              <div className={modalStyles.title}>
                {t('tv_auth.login_processing', { _: 'Logging in, please wait ...' })}
              </div>
            </div>
          </Modal>
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state),
  status: getStatus(state),
  focusedInput: getFocusedInput(state),
  username: getUsername(state),
  password: getPassword(state),
  usernameError: getUsernameError(state),
  passwordError: getPasswordError(state),
  polyglot: getP(state),
  appName: getAppName(state),
  removeRegister: selectRemoveRegister(state),
})

const mapDispatchToProps = {
  focusInput,
  updateInput,
  errorInput,
  login,
  setStatus,
  loginFacebook,
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
